import React, { useState, useEffect } from 'react';

import BackDrop from '../../shared/backdropDE';
import ErrorSnackbar from '../error-snackbar';
import MuiAlert from '@mui/material/Alert';
import * as FileSaver from 'file-saver';
import { headersExportShiftsHistoryChange } from '../../shared/constants-shifts-change';
import XLSXStyle from 'sheetjs-style';
import moment from 'moment';
import { getUser } from '../../shared/auth-service';
import dayjs from 'dayjs';
import {
    getColumns,
    getData,
    getMonthsView,
    getDataExport
} from './logic';

import {
    Grid,
    OutlinedInput,
    CircularProgress,
    Tooltip,
    Typography,
    MenuItem,
    InputLabel,
    FormControl,
    TextField,
    Box,
    Snackbar
} from "@mui/material";
import Fab from '@mui/material/Fab';
import { green } from '@mui/material/colors';
import CheckIcon from '@mui/icons-material/Check';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import BadgeIcon from '@mui/icons-material/Badge';
import DownloadIcon from '@mui/icons-material/Download';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useRef } from 'react';
import DataTable from '../../shared/data-table';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ShiftHistoryChange = () => {

    const user = getUser();
    const [loading, setLoading] = useState(true);   
    const [error, setError] = useState(null);
    const [employeeId, setEmployeeId] = useState('');
    const [startDate, setStartDate] = useState(new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1));
    const [endDate, setEndDate] = useState(new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0));
    const [monthsView, setMontsView] = useState('');
    const [loadingRows, setLoadingRows] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);

    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [severetySnackBar, setSeveretySnackBar] = useState(false);
    const [messageSnackBar, setMessageSnackBar] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const [columns, setcolumns] = useState([]);
    const [data, setData] = useState([]);

    const companyId = user.countryCode.split('-')[0];
    const company = user.countryCode.split('-')[1];

    const hasFetchedData = useRef(false);

    useEffect(() => {

        if (hasFetchedData.current) return;

        const fetchData = async () => {
            try {
                
                const MonthsView = await getMonthsView(startDate, endDate);
                //const filteredQuery = QueryFilter();
                const data = [];
                const dataColumns = await getColumns(data);               
                setMontsView(MonthsView);
                setcolumns(dataColumns);
                setData(data);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        hasFetchedData.current = true;
    }, []);


    const [successReload, setSuccessReload] = React.useState(false);
    const timer = React.useRef();
    const buttonSx = {
        ...(successReload && {
            bgcolor: green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
    };

    const [successExport, setSuccessExport] = React.useState(false);
    const buttonSxExport = {
        ...(successExport && {
            bgcolor: green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
    };

    const handleChangeStartDate = async (e) => {
        setStartDate(e);
        var MonthsView = await getMonthsView(e, endDate);
        setMontsView(MonthsView);

    };

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    const handleChangeEndDate = async (e) => {
        setEndDate(e);
        var MonthsView = await getMonthsView(startDate, e);
        setMontsView(MonthsView);
        //console.log(MonthsView);
    };

    const handleReloadQuery_ORI = async () => {
        if (!loadingRows) {

            setSuccessReload(false);
            setLoadingRows(true);

            var MonthsView = await getMonthsView(startDate, endDate);
            setMontsView(MonthsView);

            var dataColumns = await getColumns(startDate, endDate);

            var data = await getData(QueryFilter());

            setcolumns(dataColumns);
            setData(data);

            setSuccessReload(true);
            setLoadingRows(false);

            timer.current = window.setTimeout(() => {
                setSuccessReload(false);
            }, 2000);
        }
    };

    const handleReloadQuery = async () => {
        if (!employeeId) {
            OpenMessage("Debe ingresar un número de documento para filtrar", "warning");
            return;
        }
    
        if (!loadingRows) {
            setSuccessReload(false);
            setLoadingRows(true);
    
            const MonthsView = await getMonthsView(startDate, endDate);
            setMontsView(MonthsView);
    
            const data = await getData(QueryFilter());
            const dataColumns = await getColumns(data);
    
            setcolumns(dataColumns);
            setData(data);
            setShowTable(true);
    
            setSuccessReload(true);
            setLoadingRows(false);
    
            timer.current = window.setTimeout(() => {
                setSuccessReload(false);
            }, 2000);
        }
    };

    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar(false);
    };

    function QueryFilter() {
        var paramsQuery = '';

        if (employeeId !== '' && employeeId != null) {
            paramsQuery = 'Employee=' + employeeId;
        }

        if (companyId !== '' && companyId != null) {
            paramsQuery = 'CompanyId=' + companyId;
        }
     
        if (startDate !== '' && startDate !== null) {
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'StartDate=' + formatDate(startDate);
        }

        if (endDate !== '' && endDate !== null) {
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'EndDate=' + formatDate(endDate);
        }
        paramsQuery = paramsQuery + '&' + 'employeeId=' + employeeId;

        paramsQuery = paramsQuery !== '' ? '?' + paramsQuery : paramsQuery;

        return paramsQuery;
    }

    function OpenMessage(message, severety) {
        setMessageSnackBar(message);
        setSeveretySnackBar(severety);
        setOpenSnackBar(true);
    };

    const handleExport = async () => {
        if (!employeeId) {
            OpenMessage("Debe ingresar un número de documento para exportar", "warning");
            return;
        }
    
        setLoadingExport(true);
    
        const rows = await getDataExport(QueryFilter());
    
        if (!rows || rows.length === 0) {
            OpenMessage("No hay datos para exportar", "warning");
            setLoadingExport(false);
            return;
        }

        // Obtener la primera fila como encabezados
        const header = headersExportShiftsHistoryChange;

        // Agregar los encabezados como primera fila en el archivo Excel
        const ws = XLSXStyle.utils.aoa_to_sheet([header, ...rows]);

        // Estilizar los encabezados para que se vean bien en Excel
        for (let col in ws) {
            if (ws.hasOwnProperty(col)) {
                const cell = ws[col];
                const cellRef = XLSXStyle.utils.decode_cell(col);
        
                // Aplica negrita SOLO al header
                if (cellRef.r === 0) {
                    cell.s = {
                        font: { bold: true },
                        alignment: { horizontal: 'center' },
                    };
                }
            }
        }

        var fileName = "ReporteCambioTurnos_" + moment(new Date()).format('YYYYMMDDHHmmss');

        const wb = XLSXStyle.utils.book_new();
        XLSXStyle.utils.book_append_sheet(wb, ws, "data");

        const excelBuffer = XLSXStyle.write(wb, { bookType: "xlsx", type: "array" });
        const dataB = new Blob([excelBuffer], { type: fileType });

        FileSaver.saveAs(dataB, fileName + fileExtension);

        setSuccessExport(true);
        setLoadingExport(false);

        timer.current = window.setTimeout(() => {
            setSuccessExport(false);
        }, 2000);

        OpenMessage("Excel " + fileName + " exportado correctamente", "success");
    };
    
    if (loading) {
        return (<BackDrop />);
    }

    if (error) {
        return (<ErrorSnackbar message={error} />);
    }

    const getRowId = (row) => row.id;

    return (
        <>
            <Grid container spacing={2} alignItems="center" flexWrap="wrap">

                {/* Título */}
                <Grid item xs={12}>
                    <Typography style={{ color: '#00B0EF', fontWeight: 'bold', fontSize: '24px' }}>
                        Historial de Cambios de <span style={{ color: '#1A3072' }}>Turnos</span>
                    </Typography>
                </Grid>

                {/* Meses visibles */}
                <Grid item xs={12}>
                    <Typography variant="h7" style={{ color: '#00b0ef' }} fontWeight="bold">
                        {monthsView.map(item => (
                            <span key={`${item.Year}-${item.Month}`} style={{ color: '#1a3072', marginRight: 6 }}>
                                {monthsView.length > 12 ? item.Year + '-' : ''}{item.Month}
                            </span>
                        ))}
                    </Typography>
                </Grid>

                {/* Fecha Desde */}
                <Grid item xs={6} sm={3} md={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Fecha Desde"
                            inputFormat="DD/MM/YYYY"
                            value={dayjs(startDate)}
                            onChange={(e) => { setStartDate(e); handleChangeStartDate(e) }}
                            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>

                {/* Fecha Hasta */}
                <Grid item xs={6} sm={3} md={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Fecha Hasta"
                            inputFormat="DD/MM/YYYY"
                            value={dayjs(endDate)}
                            onChange={(e) => { setEndDate(e); handleChangeEndDate(e) }}
                            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>
              
                {/* Documento */}
                <Grid item xs={6} sm={3} md={2}>
                    <FormControl size="small" fullWidth>
                        <InputLabel htmlFor="search-doc">Documento</InputLabel>
                        <OutlinedInput
                            id="search-doc"
                            type="text"
                            value={employeeId}
                            onChange={(e) => setEmployeeId(e.target.value)}
                            endAdornment={<BadgeIcon />}
                            label="Documento"
                        />
                    </FormControl>
                </Grid>

                 {/* Botones + Switch */}
               <Grid item xs={12} sm={6} md={3}>
                <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems="center" gap={1}>
                    {/* Botón Filtrar */}
                    <Tooltip title="Filtrar">
                    <Box sx={{ position: 'relative' }}>
                        <Fab size="small" color="primary" sx={buttonSx} onClick={handleReloadQuery}>
                        {successReload ? <CheckIcon /> : <FilterAltIcon />}
                        </Fab>
                        {loadingRows && (
                        <CircularProgress
                            size={50}
                            sx={{ color: green[500], position: 'absolute', top: -4.9, left: -5, zIndex: 1 }}
                        />
                        )}
                    </Box>
                    </Tooltip>

                    {/* Botón Exportar */}
                    <Tooltip title="Exportar a Excel">
                    <Box sx={{ position: 'relative' }}>
                        <Fab size="small" color="primary" sx={buttonSxExport} onClick={handleExport}>
                        {successExport ? <DownloadDoneIcon /> : <DownloadIcon />}
                        </Fab>
                        {loadingExport && (
                        <CircularProgress
                            size={50}
                            sx={{ color: green[500], position: 'absolute', top: -4.9, left: -5, zIndex: 1 }}
                        />
                        )}
                    </Box>
                    </Tooltip>
                </Box>
                </Grid>


            </Grid>


            {showTable && (
                <DataTable
                    columns={columns}
                    rows={data}
                    getRowId={getRowId}
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 'bold',
                        }
                    }}
                />
            )}

            <Snackbar open={openSnackBar} autoHideDuration={4000} onClose={handleCloseSnackBar}>
                <Alert onClose={handleCloseSnackBar} severity={severetySnackBar} sx={{ width: '100%' }}>
                    {messageSnackBar}
                </Alert>
            </Snackbar>
        </>
    );
};

export default ShiftHistoryChange;
